import { Box, Button, Flex, FormControl, Select } from '@chakra-ui/react'
import type { InsuranceParamsDto, OfferVehicle, SimpleItem } from 'BrokerTsLib/src/dtos'
import { useContext, useState } from 'react'

import { FormLabel } from '../../../../components/FormLabel'
import { carkulkaOffersContext } from '../../../../context/CarkulkaOffersProvider'
import { useYearKm } from '../../../../hooks'
import { useSetOfferYearKm } from '../../../../hooks/useOffer'
import { Refresh } from '../../../../icons'
import { insuranceParamsContext } from '../../../../layouts/Wizard'
import { GetOfferElementId, scrollToOfferWithOffset } from '../../OfferCar'

export const YearlyMilageTab = ({ offer, onSavedHandler }: { offer: OfferVehicle, onSavedHandler: Function }) => {
  const { recalculateOffers: recalculate } = useContext(carkulkaOffersContext)
  const { insuranceParamsId, insuranceParams } = useContext(insuranceParamsContext)
  const isContract = !!insuranceParams?.generalParams.contractNumber

  const [isSubmitting, setIsSubmitting] = useState(false)
  const { data } = useYearKm((insuranceParams as InsuranceParamsDto).vehicle.druh!, offer.insurerId)
  const { mutateAsync: updateYearKm } = useSetOfferYearKm()

  const [yearKm, setYearKm] = useState(offer.yearKm ?? (insuranceParams as InsuranceParamsDto).vehicle.yearKm)

  // Poměrně ošklivý způsob jak namapovat kilometry allianz, kterých je méně hodnot na náš klasický select z K1.
  // Group by name
  const yearKmGroups = data?.reduce((acc, item) => {
    const group = item.name?.toString()
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(item)
    return acc
    }, {} as Record<string, SimpleItem[]>) ?? {}
    
    // Find a group that contains yearkm value as item value
  const yearKmGroupValue = yearKmGroups[Object.keys(yearKmGroups).find((group) => yearKmGroups[group].some((item) => item.value === yearKm)) ?? '']?.at(0)?.value

  return (
    <Box>
      <FormControl>
        <FormLabel>Vyberte nájezd kilometrů za rok</FormLabel>

        <Flex sx={{ flexWrap: 'wrap', gap: 4, justifyContent: 'start' }}>

          {yearKmGroups && Object.keys(yearKmGroups).length > 0 &&
            <Select value={yearKmGroupValue} onChange={(e) => setYearKm(e.target.value)} isDisabled={isContract}>
              <option disabled value=''>Vyberte roční nájezd</option>
              {Object.keys(yearKmGroups).map((group) => {
                const groupItems = yearKmGroups[group]
                return(
                    <option value={groupItems[0].value} key={group}>{group}</option>
              )})}
            </Select>
          }

          {!isContract && <Button
            variant="outline"
            isDisabled={isSubmitting}
            isLoading={isSubmitting}
            loadingText="Přepočítávám..."
            onClick={() => {
              setIsSubmitting(true)
              updateYearKm({ offerId: offer.offerId, yearKm: yearKm })
                .then(() => {
                  onSavedHandler()
                  recalculate([offer.offerId], true)
                    .then(() => setTimeout(() => scrollToOfferWithOffset(GetOfferElementId(offer.offerId)), 100))
                })
                .finally(() => {
                  setIsSubmitting(false)
                })
            }}
            gridColumnStart={1}>
            <Refresh color="secondary.500" />
            Uložit a přepočítat
          </Button>}

          {/* <ErrorSummary errors={errors} /> */}
        </Flex>
      </FormControl>
    </Box>
  )
}